import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Button, Callout, Card, Column, FullPageModal, FullPageModalHeaderStart, FullPageModalMainActions, KeyboardDatePicker, TextField, useDevice } from 'seagull';
import { ArrowRight } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { MobileDeviceEnhancer } from '~/components/MobileDeviceEnhancer/MobileDeviceEnhancer';
import { useLocaleKeys } from '~/i18n';
import styles from './AgreementTriageModal.module.scss';
import { useAgreementTriage } from './hooks/useAgreementTriage';
import { TriageRow } from './TriageRow/TriageRow';
export const GetAgreementTriageModalTID = (parentTestId)=>getTestIds(parentTestId);
const AgreementTriageModalContent = (param)=>{
    let { extraction: extractionFromProps, conversationId, dismissModal, testId } = param;
    const { AgreementTriageModalTestIds } = useMemo(()=>GetAgreementTriageModalTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const { isMobileDevice } = useDevice();
    const cardClassName = cn(styles.card, {
        [styles.cardMobile]: isMobileDevice
    });
    const { extraction, setExtraction, isSubmitting, submitCreate } = useAgreementTriage({
        extraction: extractionFromProps,
        conversationId,
        dismissModal,
        testIds: AgreementTriageModalTestIds
    });
    const paymentTermsText = extraction.paymentTermsDisplay(t);
    return /*#__PURE__*/ _jsxs(FullPageModal, {
        testId: AgreementTriageModalTestIds.Root(),
        onClose: dismissModal,
        children: [
            /*#__PURE__*/ _jsx(FullPageModalHeaderStart, {
                children: /*#__PURE__*/ _jsx("span", {
                    children: t.agreementImport.triageModal.title()
                })
            }),
            /*#__PURE__*/ _jsx(FullPageModalMainActions, {
                children: /*#__PURE__*/ _jsx(Button, {
                    testId: AgreementTriageModalTestIds.ContinueButton(),
                    onClick: submitCreate,
                    loading: isSubmitting,
                    bi: {
                        name: 'agreement_triage_continue'
                    },
                    suffixIcon: /*#__PURE__*/ _jsx(ArrowRight, {}),
                    children: t.agreementImport.triageModal.continueButton()
                })
            }),
            /*#__PURE__*/ _jsxs(Column, {
                className: styles.content,
                children: [
                    extraction.hasClientSignature() && /*#__PURE__*/ _jsx(Callout, {
                        testId: AgreementTriageModalTestIds.SignedBanner(),
                        intent: "info",
                        children: t.agreementImport.triageModal.signedBanner()
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        padding: "m",
                        className: cardClassName,
                        testId: AgreementTriageModalTestIds.FieldsCard(),
                        children: [
                            /*#__PURE__*/ _jsx(TriageRow, {
                                label: t.agreementImport.triageModal.agreementNameLabel(),
                                testId: AgreementTriageModalTestIds.AgreementNameRow(),
                                children: /*#__PURE__*/ _jsx(TextField, {
                                    testId: AgreementTriageModalTestIds.AgreementNameInput(),
                                    value: extraction.agreementName(),
                                    onChange: (e)=>setExtraction(extraction.setAgreementName(e.target.value))
                                })
                            }),
                            /*#__PURE__*/ _jsx(TriageRow, {
                                label: t.agreementImport.triageModal.effectiveDateLabel(),
                                testId: AgreementTriageModalTestIds.EffectiveDateRow(),
                                children: /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                                    testId: AgreementTriageModalTestIds.EffectiveDatePicker(),
                                    value: extraction.effectiveDate(),
                                    onChange: (date)=>setExtraction(extraction.setEffectiveDate(date))
                                })
                            })
                        ]
                    }),
                    paymentTermsText != null && /*#__PURE__*/ _jsx(Card, {
                        padding: "m",
                        className: cardClassName,
                        children: /*#__PURE__*/ _jsx(TriageRow, {
                            label: t.agreementImport.triageModal.paymentTermsLabel(),
                            testId: AgreementTriageModalTestIds.PaymentTermsRow(),
                            children: paymentTermsText
                        })
                    })
                ]
            })
        ]
    });
};
export const AgreementTriageModal = (props)=>/*#__PURE__*/ _jsx(MobileDeviceEnhancer, {
        children: /*#__PURE__*/ _jsx(AgreementTriageModalContent, _object_spread({}, props))
    });
